export default {
  completePercentage: '{percentage}% completo',
  resource: 'Recurso',
  readyToPublish: '¡Listo para publicar!',
  completeToPublish: '¡Completa para poder publicar!',
  contentMenu: {
    name: 'Título',
    picture: 'Imagen',
    rationale: 'Fundamentación',
    pedagogicalObjective: 'Objetivos pedagógicos',
    ageRanges: 'Edades asociadas'
  },
  resourceMenu: {
    presentation: 'Presentación',
    title: 'Título',
    subtopics: 'Temáticas y sub-temáticas',
    teacher: 'Docente',
    student: 'Estudiante',
    class: 'Clase {classNumber}'
  },
  resourceClassMenu: {
    organizationType: 'Organización',
    classLayout: 'Distribución',
    minutesDuration: 'Tiempo',
    necessaryMaterials: 'Materiales necesarios',
    startSection: 'Inicio',
    developmentSection: 'Desarrollo',
    closureSection: 'Cierre',
    valuationSection: 'Sugerencias de evaluación',
    studentStatement: 'Consigna'
  },
  resourcePresentationSubMenu: {
    rhetoricalQuestion: 'Pregunta disparadora',
    benefits: 'Beneficios del recurso',
    subjects: 'Áreas cruzadas asociadas',
    skills: 'Habilidades sociales',
    odSs: 'ODS asociados'
  },
  resourceTeacherSubMenu: {
    classPlanDescription: 'Plan de clases',
    pedagogicalGoal: 'Objetivos pedagógicos',
    globalValuationSection: 'Sugerencias de evaluación'
  },
  resourceStudentSubMenu: {
    studentPedagogicalGoal: 'Objetivos pedagógicos'
  }
}

export const en = {
  completePercentage: '{percentage}% complete',
  resource: 'Resource',
  readyToPublish: 'Ready to publish!',
  completeToPublish: 'Complete to publish!',
  contentMenu: {
    name: 'Title',
    picture: 'Image',
    rationale: 'Rationale',
    pedagogicalObjective: 'Educational goals',
    ageRanges: 'Associated ages'
  },
  resourceMenu: {
    presentation: 'Presentation',
    title: 'Title',
    subtopics: 'Topis and sub topics',
    teacher: 'Teacher',
    student: 'Student',
    class: 'Class {classNumber}'
  },
  resourceClassMenu: {
    organizationType: 'Organization',
    classLayout: 'Layout',
    minutesDuration: 'Time',
    necessaryMaterials: 'Materials required',
    startSection: 'Start',
    developmentSection: 'Development',
    closureSection: 'Closure',
    valuationSection: 'Suggested evaluation',
    studentStatement: 'Assignment'
  },
  resourcePresentationSubMenu: {
    rhetoricalQuestion: 'Triggering question',
    benefits: 'Benefits of the resource',
    subjects: 'Associated cross areas',
    skills: 'Social skills',
    odSs: 'Associated SDGs'
  },
  resourceTeacherSubMenu: {
    classPlanDescription: 'Lesson plan',
    pedagogicalGoal: 'Educational goals',
    globalValuationSection: 'Suggested evaluation'
  },
  resourceStudentSubMenu: {
    studentPedagogicalGoal: 'Educational goals'
  }
}

export const ca = {
  completePercentage: '{percentage}% complet',
  resource: 'Recurs',
  readyToPublish: 'Llest per publicar!',
  completeToPublish: 'Completa per poder publicar!',
  contentMenu: {
    name: 'Títol',
    picture: 'Imatge',
    rationale: 'Fonament',
    pedagogicalObjective: 'Objectius pedagògics',
    ageRanges: 'Edats associades'
  },
  resourceMenu: {
    presentation: 'Presentació',
    title: 'Títol',
    subtopics: 'Temàtiques i sub-temàtiques',
    teacher: 'Docent',
    student: 'Estudiant',
    class: 'Classe {classNumber}'
  },
  resourceClassMenu: {
    organizationType: 'Organització',
    classLayout: 'Distribució',
    minutesDuration: 'Temps',
    necessaryMaterials: 'Materials necessaris',
    startSection: 'Inici',
    developmentSection: 'Desenvolupament',
    closureSection: 'Tancament',
    valuationSection: 'Suggeriments d\'avaluació',
    studentStatement: 'Consigna'
  },
  resourcePresentationSubMenu: {
    rhetoricalQuestion: 'Pregunta disparadora',
    benefits: 'Beneficis del recurs',
    subjects: 'Àrees creuades associades',
    skills: 'Habilitats socials',
    odSs: 'ODS associats'
  },
  resourceTeacherSubMenu: {
    classPlanDescription: 'Pla de classes',
    pedagogicalGoal: 'Objectius pedagògics',
    globalValuationSection: 'Suggeriments d\'avaluació'
  },
  resourceStudentSubMenu: {
    studentPedagogicalGoal: 'Objectius pedagògics'
  }
}
